import type {StyleProps} from '@mirohq-internal/website-types'
import {createOutlineStyles} from './focus'

type Sizes = keyof typeof sizes

const mediumButtonSize = {
  borderRadius: 8,
  fontSize: 18,
  lineHeight: 24,
}

const largeButtonSize = {
  borderRadius: 8,
  fontSize: 18,
  lineHeight: 24,
}

const mediumButtonSpacing = {
  paddingTop: 8,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
}

const largeButtonSpacing = {
  paddingTop: 11,
  paddingRight: 16,
  paddingBottom: 11,
  paddingLeft: 16,
}

const sizes = {
  small: mediumButtonSize,
  medium: mediumButtonSize,
  large: largeButtonSize,
  dsSm: mediumButtonSize,
  dsMd: mediumButtonSize,
  dsLg: largeButtonSize,
}

const spacing: Record<Sizes, StyleProps> = {
  small: mediumButtonSpacing,
  medium: mediumButtonSpacing,
  large: largeButtonSpacing,
  dsSm: mediumButtonSpacing,
  dsMd: mediumButtonSpacing,
  dsLg: largeButtonSpacing,
}

const createButtonStyle = (
  variant: 'primary' | 'secondary' | 'dropdown',
  styles: StyleProps = {},
) => ({
  background: `var(--wcds-colors-background-btn-${variant}-idle)`,
  border: `1px solid var(--wcds-colors-border-btn-${variant}-idle)`,
  color: `var(--wcds-colors-text-btn-${variant}-idle)`,
  ':hover': {
    background: `var(--wcds-colors-background-btn-${variant}-hover)`,
    borderColor: `var(--wcds-colors-border-btn-${variant}-hover)`,
    color: `var(--wcds-colors-text-btn-${variant}-hover)`,
  },
  ':active, &[aria-expanded="true"]': {
    background: `var(--wcds-colors-background-btn-${variant}-down)`,
    borderColor: `var(--wcds-colors-border-btn-${variant}-down)`,
    color: `var(--wcds-colors-text-btn-${variant}-down)`,
  },
  ':focus-visible': createOutlineStyles({
    styles: {
      background: `var(--wcds-colors-background-btn-${variant}-focus)`,
      borderColor: `var(--wcds-colors-border-btn-${variant}-focus)`,
      color: `var(--wcds-colors-text-btn-${variant}-focus)`,
    },
  }),
  ...styles,
})

const primaryButtonStyles = createButtonStyle('primary')
const secondaryButtonStyles = createButtonStyle('secondary')

const buttons = {
  sizes,
  spacing,
  variants: {
    primary: primaryButtonStyles,
    secondary: secondaryButtonStyles,
    dropdown: createButtonStyle('dropdown', {
      '&& > span': {
        display: 'block',
        paddingRight: 48,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
    }),
    /**
     * @deprecated - use `primary` instead
     */
    dsPrimary: primaryButtonStyles,
    /**
     * @deprecated - use `secondary` instead
     */
    dark: secondaryButtonStyles,
    /**
     * @deprecated - use `secondary` instead
     */
    dsTransparent: secondaryButtonStyles,
    /**
     * @deprecated - use `secondary` instead
     */
    secondaryBlue: secondaryButtonStyles,
    /**
     * @deprecated - use `secondary` instead
     */
    transparent: secondaryButtonStyles,
    /**
     * @deprecated - use `secondary` instead
     */
    transparentWhite: secondaryButtonStyles,
    /**
     * @deprecated - use `secondary` instead
     */
    white: secondaryButtonStyles,
  },
  /**
   * @deprecated
   */
  withArrowSpacing: spacing,
}

export default buttons
